import React from "react";
import Image from "next/image";

interface BlogCardProps {
  imageUrl: string;
  date: string;
  category: string;
  title: string;
  description: string;
}

const BlogCard = ({
  imageUrl,
  date,
  category,
  title,
  description,
}: BlogCardProps) => {
  return (
    <div className="flex flex-col gap-3 w-full max-w-[600px] mx-auto">
      {/* Image */}
      <div className="w-full h-[200px] relative">
        <Image
          src={imageUrl}
          alt="Blog Image"
          fill
          className="object-cover object-center rounded-lg"
        />
      </div>

      {/* Date and Category */}
      <div className="flex gap-2 text-color3 text-desc-size2 font-weight2">
        <span>{date}</span> <span>{category}</span>
      </div>

      {/* Title */}
      <div className="text-desc-size2 text-color1 font-weight2">{title}</div>

      {/* Description */}
      <div className="text-desc-size2 text-color3">{description}</div>
    </div>
  );
};

export default BlogCard;
